import {
  put, takeLatest, all, select, call,
} from 'redux-saga/effects';
import { getUser } from 'circe/authentication/selectors';
import { getCurrentAuthHeader } from 'domain/fuse/auth/utils';
import { reset } from 'circe/forms/provider';
import { exception } from 'circe/logger';
import { fetch, fetched } from './actions';
import * as api from './api';

function* doFetch({ payload }) {
  const { profileId } = payload;
  const state = yield select();
  const headers = yield call(getCurrentAuthHeader, state);
  try {
    const results = yield call(api.fetch, profileId, headers);
    yield put(fetched(results));
  } catch (e) {
    exception(e);
  }
}

function* watcher() {
  yield all([takeLatest(fetch().type, doFetch)]);
}

export default watcher;
